import React, { useEffect, useState } from "react";
import { axios } from "../../../../Global";
import { setAppError, setBreadCrumb } from "../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ListDataNationality from "./ListDataNationality";
import PromptElement from "../../PromptElement";
import AddEditFormNationality from "./AddEditFormNationality";
import { printValidationError } from "../../../../utils/functions";
import { checkAccessFn } from "../../../../utils/checkAccess";
import { getNationlityData } from "../../../../store/Api";

export default function Nationality() {
  const [showPromptElement, setShowPromptElement] = useState({
    open: false,
    id: null,
  });
  const location = useLocation();
  const Nationality = useSelector((state) => state.nationalityData);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [submitFormLoading, setSubmitFormLoading] = useState(false);
  const [loading, setLoading] = useState({
    edit: false,
    delete: false,
    listData: false,
    loadingId: "",
  });
  const [clientList, setClientList] = useState([]);
  const [addOrEdit, setAddOrEdit] = useState({
    open: false,
    method: "",
    loadedValues: {},
    editId: "",
  });

  useEffect(() => {
    if (location.pathname.split("/")[3] === "create")
      setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    else setAddOrEdit((p) => ({ ...p, open: false }));
  }, [location]);

  const [name, setName] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [mobileCode, setMobileCode] = useState("");
  const token = localStorage.getItem("token");

  const getNationality = () => {
    setLoading({listData: true});
    axios
      .get("/dashboard/nationality", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
         setLoading({ listData: false });
        setClientList(res.data.data);
      })
      .catch((err) => {
        setLoading({ listData: false });
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      });
  };

  useEffect(() => {
    getNationality();
  }, []);

  const submitForm = async (event, flag) => {
    event.preventDefault();
    setSubmitFormLoading(true);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("country_code", countryCode);
    formData.append("mobile_code", mobileCode);

    if (flag) formData.append("flag_icon", flag);

    try {
      let response;
      if (addOrEdit.method === "add") {
        response = await axios.post(`/dashboard/nationality`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
      } else if (addOrEdit.method === "edit") {
        response = await axios.post(
          `/dashboard/nationality/${addOrEdit.editId}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
      }
      getNationality();
      const data = response.data.data;
      if (data) {
        dispatch(getNationlityData(token));
        dispatch(
          setAppError({
            msg: response.data.message,
            color: "bg-green-700",
          })
        );
        navigate("/dashboard/nationality");
        setSubmitFormLoading(false);
        setAddOrEdit((p) => ({ ...p, open: false }));
      }
    } catch (err) {
      printValidationError(err, "nationality");

      console.log(err);
      setSubmitFormLoading(false);
      dispatch(
        setAppError({
          msg: err?.response?.data?.message || err.message,
        })
      );
    }
  };
  const cancelForm = () => {
    navigate("/dashboard/nationality");
    setAddOrEdit((p) => ({ ...p, open: false }));
  };
  const editData = async (id, data) => {
    navigate(`/dashboard/nationality/edit/${id}`);

    if (id) {
      setLoading((p) => ({ ...p, edit: true, loadingId: id }));
      try {
        await new Promise((resolve) => setTimeout(resolve, 200));
        setLoading((p) => ({ ...p, edit: false, loadingId: "" }));
        // dispatch(getNationlityData(token))
        setAddOrEdit((p) => ({
          ...p,
          open: true,
          method: "edit",
          editId: id,
        }));
        setName(data.name);
        setCountryCode(data.country_code);
        setMobileCode(data.mobile_code);
      } catch (err) {
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      }
    }
  };
  const deleteData = async (id) => {
    if (id) {
      setLoading((p) => ({ ...p, delete: true, loadingId: id }));
      try {
        const response = await axios.delete(`/dashboard/nationality/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        getNationality();
        if (response.status === 200) {
          setLoading((p) => ({ ...p, delete: false, loadingId: "" }));
          dispatch(getNationlityData(token));
          dispatch(
            setAppError({
              msg: response.data.message,
              color: "bg-green-700",
            })
          );
        }
      } catch (err) {
        setLoading((p) => ({ ...p, delete: false }));
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
        if (err?.response?.status === 403) {
          if (err?.response?.data?.message) {
            dispatch(
              setAppError({
                msg: err?.response?.data.message,
              })
            );
          }
        }
      }
    }
  };

  const addData = () => {
    setAddOrEdit((p) => ({ ...p, open: true, method: "add" }));
    setName("");
    setCountryCode("");
    setMobileCode("");
  };

  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  const isCreateMode = location.pathname.endsWith("/nationality/create");
  const isEditMode = location.pathname.includes("/nationality/edit");

  useEffect(() => {
    if ((isCreateMode || isEditMode) && !addOrEdit.method)
      navigate("/dashboard/nationality");
  }, []);

  const commonItems = [
    { label: "NATIONALITY", link: "/dashboard/nationality" },
  ];
  const breadcrumbItems = isEditMode
    ? [...commonItems, { label: "EDIT", link: "" }]
    : isCreateMode
    ? [...commonItems, { label: "CREATE", link: "/dashboard/nationality" }]
    : commonItems;

  useEffect(() => {
    dispatch(setBreadCrumb(breadcrumbItems));
  }, [location.pathname]);

  return (
    <>
      {showPromptElement.open && (
        <PromptElement
          showPromptElement={showPromptElement}
          setShowPromptElement={setShowPromptElement}
          deleteHandler={deleteData}
        />
      )}
      <div className="p-2  sm:p-5">
        {!addOrEdit.open && (
          <>
            <ListDataNationality
              // list={Nationality}
              list={clientList}
              editData={editData}
              deleteData={setShowPromptElement}
              loading={loading}
              listLoading={loading.listData}
              titles={[
                "S.No.",
                "Flag",
                "Nationality",
                "Nationality Abbreviation",
                "Dialing Code",
                "Action",
              ]}
              addData={addData}
            />
          </>
        )}
        {addOrEdit.open && (
          <AddEditFormNationality
            component="nationality"
            form={[
              {
                type: "text",
                text: "NATIONALITY",
                name: "NATIONALITY",
                columnName: "NATIONALITY",
                value: name,
                update: setName,
              },
              {
                type: "text",
                text: "Nationality Abbreviation",
                name: "countryCode",
                columnName: "country_code",
                value: countryCode,
                update: setCountryCode,
              },
              {
                type: "text",
                text: " Dialing Code",
                name: "mobileCode",
                columnName: "mobile_code",
                value: mobileCode,
                update: setMobileCode,
              },
            ]}
            submitForm={submitForm}
            cancelForm={cancelForm}
            submitFormLoading={submitFormLoading}
            loadedValues={addOrEdit.method === "edit" && addOrEdit.loadedValues}
          />
        )}
      </div>
    </>
  );
}
